import { useState } from "react";
import SectionTitle from "@/components/SectionTitle";
import StockSearch from "@/components/StockSearch";
import AnalysisModal from "@/components/AnalysisModal";
import { Sparkles } from "lucide-react";

const POPULAR = ["BBCA", "BBRI", "BMRI", "TLKM", "ASII", "GOTO", "ANTM", "BREN", "AMMN", "MDKA"];

export default function AnalysisSearchSection() {
  const [ticker, setTicker] = useState(null);
  return (
    <section id="analisis" className="scroll-mt-20">
      <SectionTitle
        eyebrow="AI Screener · 950+ Emiten IDX"
        title="Analisis AI Saham Apa Saja"
        desc="Ketik kode atau nama emiten, lalu dapatkan skor AI 4 pilar (Bandarmology, Technical, Fundamental, News) untuk seluruh saham di Bursa Efek Indonesia."
        icon={Sparkles}
      />
      <div className="card p-6">
        <StockSearch onSelect={(code) => setTicker(code)} />
        <div className="mt-4 flex flex-wrap items-center gap-2">
          <span className="text-xs text-[var(--text-muted)]">Populer:</span>
          {POPULAR.map((c) => (
            <button key={c} onClick={() => setTicker(c)} data-testid={`popular-${c}`} className="px-2.5 py-1 rounded-md bg-[var(--surface-base)] border border-[var(--border)] text-xs font-semibold font-mono-data text-[var(--text-secondary)] hover:text-accent hover:border-[var(--accent)]/40 transition-colors">
              {c}
            </button>
          ))}
        </div>
      </div>
      {ticker && <AnalysisModal ticker={ticker} onClose={() => setTicker(null)} />}
    </section>
  );
}
